export default __webpack_public_path__ + "static/media/PAFI_Pemanggilan RUPS LB 2025.2904ac3c.pdf";